import { createRoot } from 'react-dom/client';

const container = document.getElementById('root');
export const hubRoot = createRoot(container!);
